import React, { useEffect, useState } from "react";
import { GuiasContainer } from "./styles";
import api from "../../services/api";
import { Container } from "react-grid-system";
import GenericUpper from "../../components/generic-upper";
import TableWithLabelBlackV2 from "../../components/TableWithLabelBlack/indexV2";
import IconTrashRed from '../../assets/icons/icon-trash-red.png';
import { BodyM, TaglineP } from "../../styles/stylesTypography";
import { theme } from "../../styles/theme";
import DotsLoader from "../../components/loader";
import { store } from "react-notifications-component";
import CardGeral from "../../components/card-geral/index";
import ModalTesteGratisAcabou from '../../components/modal/modalFuncaoBloqueada';
import ModalConfirmar from "../../components/modal/modalConfirmar";
import PaginatorV2 from "../../components/paginator/indexV2";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
export const USER = "@userinfo";
export const VAL = "@validade";

const IconEyeGray = "data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2321262F' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8Z'/%3E%3Ccircle cx='12' cy='12' r='3'/%3E%3C/svg%3E";

const GuiasAplicacao = ({ ...props }) =>  {
    const [guias, setGuias] = useState([]);
    const [limit, setLimit] = useState(30);
    const [offset, setOffset] = useState(0);
    const [totalGuias, setTotalGuias] = useState(0);
    const [result, setResult] = useState("");
    const [result2, setResult2] = useState("");
    const [idGuia, setIdGuia] = useState(null);
    const [size_screen, setSizeScreen] = useState(window.screen.width);
    const [modalTesteGratisAcabou, setModalTesteGratisAcabou] = useState(false);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showModalGuides, setShowModalGuides] = useState(false);

    const updateValues = async (text, estado, searchP) => {
        if (searchP === 1) {
            if (!text && !estado) {
                search('', '', 30, 0);
            } else {
                setResult2(estado);
                setResult(text);
                search(text, estado, 30, 0);
            }
        } else {
            setResult(text);
            setResult2(estado);
        }
    }

    const search = async (result, result2, limit, offset) => {
        try {
            setLoadingSearch(true);
            const search = result;
            const estado = result2;

            const payload = {
                search,
                estado
            }

            const response = await api.post(`/guias/historico?limit=${limit}&offset=${offset}`, payload);

            setGuias(response.data.guias);
            setTotalGuias(response.data.total);
            setLoadingSearch(false);

        } catch (error) {
            setLoadingSearch(false);
        }
    };


    const formatDate = (data) => {
        if (!data) return "-";
        
        try {
            const dateParts = data.split('T')[0].split('-');
            if (dateParts.length !== 3) return data; 
            
            const year = dateParts[0];
            const month = dateParts[1];
            const day = dateParts[2];
            
            return `${day}/${month}/${year}`;
        } catch (e) {
            return data; 
        }
    };

    const deleteGuide = async (id) => {
        try {
            const response = await api.delete(`/guias/${id}`);
            if(response.data.message){
                store.addNotification({
                    title: "Sucesso!",
                    message: `${response.data.message}`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                setTimeout(() => {
                    window.location = "/guia_aplicacao"
                }, 1000);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }


    const resposta = async (resposta, id) => {
        if (resposta === 1 && id) {
            deleteGuide(id);
        }
        setShowModalGuides(false);
    };

    const updateLimitOffset = (l,o) => {
        if (l !== limit || o !== offset) {
            setLimit(l);
            setOffset(o);

            search(result, result2, l, o);
        }
    }

    useEffect(()=>{
        window.scrollTo(0, 0);

        search('', '', 30, 0);
        setInterval(async()=>{
            setSizeScreen(window.screen.width);
        }, 990);
    }, [])

    useEffect(()=>{
    })

    return (
        <>
            <GenericUpper
                title="Guias de Aplicação"
                subtitle="Gerencie seus guias de aplicação emitidos"
                help={true}
                text={"Para emitir o guia de aplicação encontre a receita com o produto desejado na tela de histórico, clique no ícone e preencha os dados da guia. Depois disso, suas guias aparecerão nessa tela."}
                search={true}
                searchFunction={(text) => updateValues(text, '', 1)}
                placeholder="N.Receita, Produto, Praga, Cultura ou Aplicador"
                addButton={true}
                tooltip={"Emitir Guia"}
                linkSearch = {'/historico'}
            ></GenericUpper>

            <GuiasContainer>
                <Container style={{}}>
                    <TableWithLabelBlackV2
                        columns={[
                            {
                                key: 'numero',
                                label: 'N.Receita',
                                minWidth: '90px',
                                width: '100%',
                                maxWidth: '200px',
                                enableHorizontalScroll: true,
                                render: (g) => (
                                    <BodyM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                                        {g.agro_prescriptions?.numero}
                                    </BodyM>
                                )
                            },
                            {
                                key: 'produto',
                                label: 'Produto (Praga)',
                                width: '100%',
                                minWidth: '200px',
                                maxWidth: '380px',
                                maxWidthContent: '380px',
                                enableHorizontalScroll: true,
                                render: (g) => (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                        {g.agro_prescriptions?.agro_prescriptions_relations?.length > 0
                                            ? g.agro_prescriptions.agro_prescriptions_relations.map((re, i) => (
                                                <TaglineP key={i} color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                                    <b>{re.nome_comercial}</b> ({re.praga_nome_comum})
                                                </TaglineP>
                                            ))
                                            : (
                                                <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                                    <b>{g.nome_comercial}</b> ({g.praga})
                                                </TaglineP>
                                            )
                                        }
                                    </div>
                                )
                            },
                            {
                                key: 'cultura',
                                label: 'Cultura',
                                width: '100%',
                                minWidth: '120px',
                                maxWidth: '200px',
                                maxWidthContent: '200px',
                                enableHorizontalScroll: true,
                                render: (g) => (
                                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                        {g.agro_prescriptions?.cultura_nome_comum}
                                    </TaglineP>
                                )
                            },
                            {
                                key: 'aplicador',
                                label: 'Aplicador',
                                width: '100%',
                                minWidth: '140px',
                                maxWidth: '250px',
                                maxWidthContent: '250px',
                                enableHorizontalScroll: true,
                                render: (g) => (
                                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                        {g.agro_applicators?.name_applicator}
                                    </TaglineP>
                                )
                            },
                            {
                                key: 'application_date',
                                label: 'Aplicação',
                                width: '100%',
                                minWidth: '120px',
                                maxWidth: '200px',
                                render: (g) => (
                                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={600}>
                                        {formatDate(g.application_date)}
                                    </TaglineP>
                                )
                            }
                        ]}
                        data={guias}
                        showAll={true}
                        isLoading={loadingSearch}
                        serverSide={true}
                        itemsPerPage={guias.length || limit}
                        enableDefaultRowNavigation={false}
                        emptyMessage="Nenhum resultado encontrado."
                        actionsColumn={{
                            enabled: true,
                            position: "first",
                            label: "AÇÕES",
                            width: "100%",
                            minWidth: "70px",
                            maxWidth: "120px",
                            justifyContent: "flex-start",
                            buttons: [
                                {
                                    key: "delete",
                                    icon: IconTrashRed,
                                    iconAlt: "Apagar guia",
                                    tooltip: "Apagar guia",
                                    ariaLabel: "Apagar guia",
                                    onClick: (guia) => {
                                        setIdGuia(guia.id);
                                        setShowModalGuides(true);
                                    }
                                },
                                {
                                    key: "view",
                                    icon: IconEyeGray,
                                    iconAlt: "Visualizar guia",
                                    tooltip: "Visualizar guia",
                                    ariaLabel: "Visualizar guia",
                                    onClick: (guia) => {
                                        window.open(guia.url_guide, '_blank');
                                    }
                                }
                            ]
                        }}
                    />

                    <PaginatorV2 
                        perPage={limit} 
                        total={totalGuias} 
                        onChange={(limit, offset) => updateLimitOffset(limit, offset)}
                        totalItens={guias.length}
                    />

                    <div 
                        className="button-finish" 
                        style={{ 
                            width: '100%', 
                            display: 'flex', 
                            flexDirection: 'row', 
                            justifyContent: 'space-evenly',
                            alignItems: 'center', 
                            marginTop: '40px',
                        }}
                    >
                    </div>

                    <ModalTesteGratisAcabou
                        show={modalTesteGratisAcabou}
                        title="Essa é uma função exclusiva para assinantes..."
                        subtitle="Assine o Agroreceita para desbloquear todos os recursos abaixo:"
                        onHide={() => {
                            setModalTesteGratisAcabou(false);
                            window.location.href="/"
                        }}
                    ></ModalTesteGratisAcabou>

                    <ModalConfirmar
                        show={showModalGuides}
                        text="Digite 'CANCELAR' para continuar o cancelamento do guia" 
                        title="Confirmar Cancelamento do Guia de Aplicação"
                        id={idGuia}
                        update={resposta}
                        onHide={() => setShowModalGuides(false)}
                    />
                </Container>
            </GuiasContainer>
        </>
    );
}
export default GuiasAplicacao;